module.exports = __webpack_public_path__ + "static/img/solution.98dd8cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/solution.png
// module id = XjpH
// module chunks = 11